import { PageTitleWithHelp } from "@/components/ui/title-help";

export function WarehouseSettingsPage(): JSX.Element {
  return (
    <div className="space-y-4">
      <header>
        <PageTitleWithHelp hoverHint="Warehouse module settings. Inventory discrepancy notifications are configured under Manufacturing management settings.">
          Warehouse · Settings
        </PageTitleWithHelp>
      </header>

      <p className="text-sm text-slate-600">
        Carton quantity changes and other inventory discrepancies are approved on{" "}
        <a
          href="/manufacturing-management/inventory-discrepancies"
          className="text-sky-700 hover:text-sky-900 hover:underline"
        >
          Inventory discrepancies
        </a>
        . Topic owners for that queue live on{" "}
        <a
          href="/manufacturing-management/settings"
          className="text-sky-700 hover:text-sky-900 hover:underline"
        >
          Manufacturing management settings
        </a>
        .
      </p>
    </div>
  );
}
